import { render, staticRenderFns } from "./PurchaseOrderPreview.vue?vue&type=template&id=38a75e3f&scoped=true&"
import script from "./PurchaseOrderPreview.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderPreview.vue?vue&type=style&index=0&id=38a75e3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a75e3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a75e3f')) {
      api.createRecord('38a75e3f', component.options)
    } else {
      api.reload('38a75e3f', component.options)
    }
    module.hot.accept("./PurchaseOrderPreview.vue?vue&type=template&id=38a75e3f&scoped=true&", function () {
      api.rerender('38a75e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/PurchaseOrderPreview.vue"
export default component.exports